// extracted by mini-css-extract-plugin
export default {"container":"World_container__e0aZE","paragraphContainer":"World_paragraphContainer__K98Xr"};